import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppRoute } from '@app/shared/app.route.enum';
import { __ } from '@app/shared/functions/object.functions';
import { ToastrService } from '@app/shared/services/toast.service';

import { Logger } from '../logger.service';
import { RouteService } from '../route.service';
import { AuthenticationService } from './authentication.service';

const _log = new Logger('AuthenticationGuard');

@Injectable()
export class AuthenticationGuard {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authenticationService = inject(AuthenticationService);
  private toastr = inject(ToastrService);
  private location = inject(Location);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.authenticationService.isAuthenticated()) {
      const data = RouteService.MergeData(route);

      if (!__.IsNullOrUndefined(data['roles'])) {
        const allowed = this.authenticationService.hasAnyRole(data['roles'] as string[]);
        if (allowed) {
          return true;
        } else {
          return this.checkForbidden(route);
        }
      }

      return true;
    }

    this.toastr.error('You are not logged in. Please login to continue to this website');
    this.authenticationService.logout();
    this.router.navigate([`/${AppRoute.Login}`], { replaceUrl: true });
    return false;
  }

  private checkForbidden(_route: ActivatedRouteSnapshot): boolean {
    const currentUrl = this.router.url;
    if (currentUrl === '/' || currentUrl.includes(AppRoute.Dashboard)) {
      return true;
    }
    this.toastr.error(
      'You are not allowed to view this page. Please ask your administrator for permissions to view this page',
    );
    this.router.navigate([`/${AppRoute.Dashboard}`], { replaceUrl: true });

    return false;
  }
}
